import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { SupplementType } from 'modules/payroll_bundle/components/common/helper/worksheet'
import { isValid } from 'modules/payroll_bundle/pages/SupplementsPage/BulkImport/_components/_Table/RowValidations'
import getSupplementsAmounts from 'modules/payroll_bundle/pages/SupplementsPage/helpers/getSupplementsAmounts'
import getTotalAmountFormatted from 'modules/payroll_bundle/pages/SupplementsPage/helpers/getTotalAmountFormatted'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

const OptionsBottom = ({
  supplements,
  supplementTypes,
  selected,
}: {
  // Supplement actually represents an imported row, i.e. an employee and their supplements
  supplements: Supplement[]
  supplementTypes: SupplementType[]
  selected?: Set<number>
}) => {
  const selectedValidRows = supplements.filter(
    (row) => selected?.has(row.id) && isValid(row, supplementTypes)
  )
  const supplementAmounts = getSupplementsAmounts(selectedValidRows, supplementTypes)
  const totalAmountFormatted = getTotalAmountFormatted(supplementAmounts)

  return (
    <Box
      width="full"
      alignItems="center"
      flexDirection="row"
      background="grey200"
      justifyContent="spaceBetween"
    >
      <Text.Normal>
        {i18n.t('payroll_bundle.import_supplements.review_and_import.x_of_y_rows_selected', {
          x: selectedValidRows.length,
          // `supplements` has the same number of items as context's `importedSupplements`
          y: supplements.length,
        })}
      </Text.Normal>

      {Boolean(totalAmountFormatted) && (
        <Text.Normal>
          {i18n.t('payroll_bundle.import_supplements.review_and_import.total_amount', {
            amount: totalAmountFormatted,
          })}
        </Text.Normal>
      )}
    </Box>
  )
}

export default observer(OptionsBottom)
